/**
 * Created by dushyantha on 9/15/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name profile.controller:ProfileCtrl
     *
     * @description
     *
     */
    angular
        .module('crewProfile')
        .controller('ProfileCtrl', ProfileCtrl);

    function ProfileCtrl(CommonMasterData, crewScheduleService, ProfileService, MessageService,CrewingSelectionHelper,CrewingAdaptor,CrewingHelper,
                         applicationConstants, EventManagerService,StorageServices,TabService, $stateParams, PopupManager, crewingConstants,crewSchAssignTraningModel,
                         crewSchAssignTraningLogic,SlideInPanelService,crewProfileDTOFactory) {
        var vm = this;

        vm.model = {
            crewTypes: [],
            searchParam: {
                crewID: $stateParams.crewId
            },
            searchCriteria : {
              nationality : null
            },
            crewDetails: {},
            showSearchArea: false,
            createNewProfile: false,
            showCivilId: true,
            crewBatchList: [],
            crewAttributeList: [],
            alvGroups: [],
            crewGroups: [],
            offContracts: [],
            baseType: [],
            nationalityList: [],
            mgtPositions: [],
            crewPositionList:[],
            languageList: [],
            trainerTypes: [],
            trainerTypesForTrainingStages: [],
            defaultValidations: [],
            crewLanguageSkills: [],
            fleetExperienceDetails: [],
            crewBaseAssignments: [],
            secondaryCrewBaseAssignments : [],
            effectedBaseList:[],
            aircraftTypes: [],
            paymentDetails: {},
            crewPaymentRangeDetails : [],
            crewOtherPaymentDetails : {},
            crewUpgradeData: [],
            crewTrainingStages: [],
            airportExclusion: [],
            airportInclusion: [],
            imageUrl: '',
            crewOperTypes :[],
            baseList:[],
            newCrewBasePopover: {
                popOverFlag: false
            },
            newCrewSecondaryBasePopover: {
                popOverFlag: false
            },
            lastCrewBaseOpenPopOver: {popOverFlag: false},
            lastCrewSecondaryBaseOpenPopOver: {popOverFlag: false},
            newDateRangePopover: {
              popOverFlag: false
            },
            lastDateRangeOpenPopOver: {popOverFlag: false},
            actualScheduleSearchParam : {},
            publishScheduleSearchParam : {},
            passportParamValue :{},
            hubList : [],
            autoImportAllowedClients : [],
            isEnableRosterTab :false,
            dobAfterToday : false,
            passportIssuedDateAfterToday : false,
            crewTypeWiseNameList:[],
            countryNameWiseAirportList:[],
            crewACMIAssignmentRanges:[],
            assignedCrewBatches:[],
            newACMIRangePopover: {
              popoverFlag: false
            },
            acmiTypes : [],
            crewAirportRecency: [],
            crewLayoverAccommodationPreferences: [],
            airportRecencyLastRefreshTime: null,
            defaultPasswordsList: [],
            userRoles: [],
            passwordRegexMisMatch: false,
            designationList: [],
            selectedRow : null
        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.OPEN_MEMO, openMemoListener);

        vm.crewBasePopOver = {};

        vm.crewSecondaryBasePopOver = {};

        vm.dateRangePopOver = {};

        vm.rightPanelName = 'crewing.right.panel';

        vm.calendar = [],
        vm.weekDays = moment.weekdaysShort(true);

        var moStart = moment().startOf("month");
        var moEnd = moment().endOf("month");
        vm.fromDate = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);
        vm.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);

        vm.scheduleSearchDetails = {
            fromDate : vm.fromDate,
            toDate : vm.toDate,
            crewBase:{airPortCode:''},
            crewType:{crewType:''},
            days:'',
            crewDetails:'',
            crewID:'',
            fleetExperince:''

        }

        vm.model.searchDetails = [];
        vm.model.actualScheduleSearchParam = [];
        vm.crewDetails = [];
        vm.managementPosition = [];

        vm.addAcmiRangePopover = {
          a320Qualified: true,
          a321Qualified: true,
          acmiType : ''
        };

        loadBasicPageData();

        function loadBasicPageData() {
          //  getCivilIdStatus();
            loadCrewTypes();
            loadCrewBatchList();
            loadCrewAttributeList();
            getCrewGroups();
            getAlvGroups("");
          getOffContracts();
            getCrewBaseTypes();
            getNationalityList();
            getManagementCrewPositions();
            getLanguageList();
            getTrainerTypes();
            getAirCraftTypes();
            getAirportList();
            loadCrewListWithoutLimit();
            getHubDetails();
            loadOperationalType();
            getPassportParam();
            getAutoImportAllowedClients();
            getCivilIdStatus();
            loadIsEnableRosterTab();
            loadUserRoles();
            getCrewDesignation();

        }

        vm.openSearchPanel = function () {

        };

      function MultiSelectNode() {
        this.labelFieldName = null;
        this.valueFieldName = null;
        this.childElements = null;
        this.startedDate = null;
        this.selected = true;
        this.changed = false;
      }

        vm.onDefaultValidationSave = function () {
            var param = {
                crewProfileId: vm.model.crewDetails.crewProfileId,
                defaultValidations: vm.model.defaultValidations
            }
            ProfileService.saveCrewDefaultValidation(param,
                function (response) {
                    if (response.success) {
                        MessageService.success('Save Default Validations Successfull');
                    } else {
                        MessageService.error('Save Default Validations Failed');
                    }

                },
                function (error) {
                    MessageService.error(error);
                })
        };

        vm.onCrewTypeChange = function (crewTypeCode) {
            ProfileService.getCrewTypeDefaultValidation(crewTypeCode,
                function (defaultValidations) {
                    vm.model.defaultValidations = defaultValidations;
                },
                function (error) {
                    MessageService.error(error);
                }
            );
            getAlvGroups(crewTypeCode);
            if (vm.model.createNewProfile) {
              vm.model.passwordRegexMisMatch = false;
              setDefaultPassword(crewTypeCode);
            }

        };

      function getCivilIdStatus() {
        CommonMasterData.getCivilIdStatus(
          function (showCivilId) {
            vm.model.showCivilId = showCivilId;
          },
          function () {
            console.log('showCivilId status retrieval error');
          }
        );
      }

        function getCrewDesignation() {
            CommonMasterData.getCrewDesignationList(
                function (designations) {
                    vm.model.designationList = designations;
                },
                function () {
                    console.log('Crew designation list retrieval error');
                }
            );
        }

        function loadCrewTypes() {
            CommonMasterData.getCrewTypeList(
                function (crewTypes) {
                    vm.model.crewTypes = crewTypes;
                },
                function () {
                    console.log('Crew type retrieval error');
                }
            );
        }

        function loadUserRoles() {
            CommonMasterData.getUpdatedRoleNameList(
                function (roles) {
                    vm.model.userRoles = roles;
                },
                function () {
                    console.log('User roles retrieval error');
                }
            );
        }

        //todo: pageSize issue need to handle in backend
        function loadCrewBatchList() {
            var param = {
                "description": "",
                "pageSize": -1,
                "startPosition": 1

            };
            CommonMasterData.getCrewBatchList(param,
                function (crewTypes) {
                    vm.model.crewBatchList = crewTypes;
                },
                function () {
                    console.log('Crew batch retrieval error');
                }
            );
        }


        function loadCrewAttributeList() {
            var param = {
                "description": "",
                "pageSize": -1,
                "startPosition": 1

            };
            CommonMasterData.getCrewAttributeList(param,
                function (crewAttributes) {
                    vm.model.crewAttributeList = _.map(crewAttributes, function (attribute) {
                        var copy = angular.copy(attribute);
                        copy.displayLabel = copy.description + ' (' + copy.status + ')';
                        return copy;
                    });
                },
                function () {
                    console.log('Crew attribute list retrieval error');
                }
            );
        }

        function getCrewGroups() {
            CommonMasterData.getCrewGroups(
                function (response) {
                    vm.model.crewGroups = response.crewGroups;
                },
                function () {
                    console.log('Crew Groups retrieval error');
                }
            );
        }

      function getOffContracts() {
        CommonMasterData.getOffContracts(
          function (response) {
            vm.model.offContracts = response.offContracts;
          },
          function () {
            console.log('Off Contracts retrieval error');
          }
        );
      }

        function getCrewBaseTypes() {
            CommonMasterData.getCrewBaseList(
                function (crewBase) {
                    vm.model.baseType = crewBase;
                }, function () {
                    console.log('Crew base list retrieval error');
                }
            )
        }

        function getNationalityList() {
            CommonMasterData.getNationalityList(
                function (response) {
                    vm.model.nationalityList = response;
                }, function () {
                    console.log('Nationality list retrieval error');
                }
            )
        }

        function getManagementCrewPositions() {
            ProfileService.getManagementCrewPositions(
                function (response) {
                  vm.managementPosition = response;
                  vm.model.mgtPositions = response;
                },
                function (error) {
                    MessageService.error(error[0]);
                }
            );
        }

        function setManagementCrewPosition(response){
        vm.managementPosition = response;
        }

          function getPassportParam() {
            CommonMasterData.getPassportParamValue(
            function (response) {
              vm.allowPassportValidation = response;
            },

            function () {
              console.log('Passport param Value error');
            }
          );
          }

        function loadCrewList(crewType,isActive, crewProfileId) {
            var param = {};
            param.crewType = crewType;
            if(!isActive){
            param.active = true;
            }else if(isActive == "all") {
              param.active = null;
            }
            CommonMasterData.loadCrewList(param,
                function (response) {
                    vm.model.crewList = crewScheduleService.adaptCrewList(response);
                    vm.model.crewTypeWiseNameList = crewGroupByCrewTypeAfterSearch(crewProfileId);
                },
                function () {
                    console.log('Crew list retrieval error');
                }
            );
        }

        function getAirCraftTypes() {
            CommonMasterData.getAircraftTypeList(
              function (aircrafts) {

                vm.model.aircraftTypes = getUniqueRecords(aircrafts);

                },
                function () {
                    console.log('Aircraft type retrieval error');
                }
            );
        }

        function getUniqueRecords(aircrafts){
        	var list =[];
        	var uniqueList =[];
        	_.each(aircrafts, function (obj) {

               if(!list.includes(obj.airCraftType)) {
            	   list.push(obj.airCraftType);
            	   uniqueList.push(obj);
               }

            });

        	return uniqueList;
        }

        function getAirportList() {

            CommonMasterData.getAirportList(
                function (response) {
                    vm.model.airports = response;
                    vm.model.countryNameWiseAirportList =airpotsByCountryName();
                }, function () {

                }
            )
        }

        function getLanguageList() {
            CommonMasterData.getLanguageList(
                function (response) {
                    vm.model.languageList = response;
                }, function () {
                    console.log('Crew Language list retrieval error');
                }
            )
        }

        function getDefaultPasswords() {
            CommonMasterData.getDefaultPasswords(
                function (response) {
                    vm.model.defaultPasswordsList = response;
                }, function () {
                    console.log('Crew Default Passwords list retrieval error');
                }
            )
        }

        function getHubDetails() {
            ProfileService.getHubDetails(
                function (response) {
                    vm.model.hubList = response.flyingHourHubs;
                },
                function (error) {
                    console.log('Hub list retrieval error');
                }
            );
        }

        function getAutoImportAllowedClients() {
            ProfileService.getAutoImportAllowedClients(
                function (response) {
                    vm.model.autoImportAllowedClients = response.availableHubForImportDTOS;
                },
                function (error) {
                    console.log('Auto Import Allowed Client list retrieval error');
                }
            );
        }

        function loadOperationalType(){
        	 CommonMasterData.crewOperTypes(
                     function (response) {
                      vm.model.crewOperTypes = response;
                     }, function () {}
                 );
        }

        function loadIsEnableRosterTab(){
       	 CommonMasterData.isEnableRosterTabFromProfile(
                    function (response) {
                     vm.model.isEnableRosterTab = response;
                    }, function () {}
                );
       }

        vm.loadCrewListByType = function (crewType,isActive) {
            loadCrewList(crewType,isActive);
        };

        vm.onSearchCrewProfile = function (searchParam) {
        	SlideInPanelService.closeAllPanels();
            vm.model.dobAfterToday = false;
            vm.model.passportIssuedDateAfterToday = false;
            vm.model.searchParam.fromDate = vm.fromDate;
            vm.model.searchParam.toDate = vm.toDate;
            vm.model.searchParam.crewId = searchParam;
            vm.model.searchParam.crewID = searchParam;

            vm.model.actualScheduleSearchParam = crewScheduleService.adaptStateParams(vm.model.searchParam);
            vm.model.actualScheduleSearchParam.crewIds = searchParam;

            vm.model.searchDetails = angular.copy(vm.model.searchParam);//vm.model.search

            vm.model.showSearchArea = false;

            CommonMasterData.model.languageList = null;
            getLanguageList();

            searchCrewProfile();

        };

        vm.addEditFleetExperience = function (fleetDTO) {
            var param = {};
            param.crewProfId = vm.model.crewDetails.crewProfileId;
            param.crewTypeCode = fleetDTO.crewTypeCode && fleetDTO.crewTypeCode.crewTypeCode;
            param.modelNumber = fleetDTO.model.airCraftType;
            param.fleetExperienceId = fleetDTO.crewProfileFleetExpeId;
            param.flying = !fleetDTO.flying;
            param.crewProfId = vm.model.crewDetails.crewProfileId;
            param.dayFlyingHours = null;
            param.nightFlyingHours = null;
            param.version = fleetDTO.version;
            //Blueline set
            param.blueLine = !fleetDTO.blueLineParams.enabled;
            if(param.blueLine){
                param.blueLineStartTime = moment().format(applicationConstants.SETTINGS.TIME_FORMAT);
                param.blueLineStartDate = moment(fleetDTO.blueLineParams.startDate, applicationConstants.SETTINGS.DATE_FORMAT).format(applicationConstants.SETTINGS.DATE_FORMAT);
                param.blueLineEndedDate = fleetDTO.blueLineParams.endDate;
                param.blueLineEndedTime = fleetDTO.blueLineParams.endTime;
            }else{
                param.blueLineStartTime = fleetDTO.blueLineParams.startTime;
                param.blueLineStartDate = fleetDTO.blueLineParams.startDate;
                param.blueLineEndedDate = moment().format(applicationConstants.SETTINGS.DATE_FORMAT);
                param.blueLineEndedTime = moment().format(applicationConstants.SETTINGS.TIME_FORMAT);
            }
            //Recency set
            param.fleetClearanceDate = fleetDTO.fleetClearanceDate;

            ProfileService.addEditFleetExperience(param,
                function (response) {
                    if (response.success) {
                        getFleetExperience();
                        getDefaultValidations(vm.model.crewDetails.crewProfileId)
                        MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                    }

                },
                function (error) {
                    MessageService.error(error);
                }
            );

        };

        vm.addEditCrewBase = function () {
            var param = {};
            param.crewBaseAssignmentId = vm.crewBasePopOver.crewBaseAssignmentId;
            param.crewProfileId = vm.model.crewDetails.crewProfileId;
            param.effectiveFromDate = vm.crewBasePopOver.effectiveFromDate;
            param.base = vm.crewBasePopOver.crewBase.airPortCode;
            param.version = vm.crewBasePopOver.version;
            param.joinedDate=vm.crewBasePopOver.joinedDate;
            param.updateType=vm.crewBasePopOver.updateType;
            param.employerHub = vm.crewBasePopOver.employerHub.hubCode;
            param.postingType = vm.crewBasePopOver.postingType ? vm.crewBasePopOver.postingType.value : null;
            param.remarks = vm.crewBasePopOver.remarks;
            ProfileService.addEditCrewBase(param,
                function (response) {
                    if (response.success) {
                        getCrewBaseAssignmentData();

                        vm.crewBasePopOver = {popOverFlag : false};
                        vm.model.lastCrewBaseOpenPopOver= {popOverFlag : false};
                        vm.model.newCrewBasePopover={popOverFlag : false};

                        MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        vm.addEditCrewSecondaryBase = function () {
          var param = {};
          param.crewBaseAssignmentId = vm.crewSecondaryBasePopOver.crewBaseAssignmentId;
          param.crewProfileId = vm.model.crewDetails.crewProfileId;
          param.effectiveFromDate = vm.crewSecondaryBasePopOver.effectiveFromDate;
          param.effectiveToDate = vm.crewSecondaryBasePopOver.effectiveToDate;
          param.base = vm.crewSecondaryBasePopOver.crewBase.airPortCode;
          param.version = vm.crewSecondaryBasePopOver.version;
          param.joinedDate=vm.crewSecondaryBasePopOver.joinedDate;
          param.updateType=vm.crewSecondaryBasePopOver.updateType;
          param.employerHub = vm.crewSecondaryBasePopOver.employerHub.hubCode;
          param.postingType = vm.crewSecondaryBasePopOver.postingType ? vm.crewSecondaryBasePopOver.postingType.value : null;
          param.remarks = vm.crewSecondaryBasePopOver.remarks;
          param.primary = false;
          ProfileService.addEditCrewSecondaryBase(param,
              function (response) {
                  if (response.success) {
                      getSecondaryCrewBaseAssignmentData();

                      vm.crewSecondaryBasePopOver = {popOverFlag : false};
                      vm.model.lastCrewSecondaryBaseOpenPopOver= {popOverFlag : false};
                      vm.model.newCrewSecondaryBasePopover={popOverFlag : false};

                      MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                  }
              },
              function (error) {
                  MessageService.error(error);
              }
          );
      };

      vm.addEditPositionDateRange = function (positionDateRangeDTO) {
        var param = {};
        param.crewProfManagePosId = positionDateRangeDTO.crewProfManagePosId;
        param.crewProfileId = vm.model.crewDetails.crewProfileId;
        param.managementPosCode = positionDateRangeDTO.crewPosition.crewPositionCode;
        param.startDate = positionDateRangeDTO.dateOfStart;
        param.endDate = positionDateRangeDTO.dateOfEnd;
        param.version = -1;

        ProfileService.addEditPositionDateRange(param,
          function (response) {
            if (response.success) {
              // var msg = response.messages[0];
              if((response.messages==null)) {
                searchProfileDetailAfterPositionUpdate(vm.model.crewDetails.crewId);

                vm.dateRangePopOver = {popOverFlag: false};
                vm.model.lastDateRangeOpenPopOver = {popOverFlag: false};
                vm.model.newDateRangePopover = {popOverFlag: false};

                MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
              }else{
                MessageService.error("Date range overlapping.");
                // MessageService.success(MessageService.MESSAGES.COMMON.MNG_POSITION_DATE_OVERLAP);
              }
            }
          },
          function (error) {
            MessageService.error(error);
          }
        );
      };

        vm.deleteCrewBaseController = function (crewBaseDTO) {
            var param = {};
            param.crewBaseAssignmentId = crewBaseDTO.crewBaseAssignmentId;
            param.crewProfileId = vm.model.crewDetails.crewProfileId;
            param.effectiveFromDate = crewBaseDTO.effectiveFromDate;
            param.base = crewBaseDTO.crewBase.airPortCode;
            param.version = crewBaseDTO.version;

            ProfileService.deleteCrewBaseService(param,
                function (response) {
                    if (response.success) {
                        getCrewBaseAssignmentData();

                        vm.crewBasePopOver = {popOverFlag : false};
                        vm.model.lastCrewBaseOpenPopOver= {popOverFlag : false};
                        vm.model.newCrewBasePopover={popOverFlag : false};

                        MessageService.success(MessageService.MESSAGES.CREW_PROFILE.DELETE_SUCCESS);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

      vm.deleteCrewSecondaryBaseController = function (crewBaseDTO) {
          var param = {};
          param.crewBaseAssignmentId = crewBaseDTO.crewBaseAssignmentId;
          param.crewProfileId = vm.model.crewDetails.crewProfileId;
          param.effectiveFromDate = crewBaseDTO.effectiveFromDate;
          param.effectiveToDate = crewBaseDTO.effectiveToDate;
          param.base = crewBaseDTO.crewBase.airPortCode;
          param.version = crewBaseDTO.version;

          ProfileService.deleteCrewSecondaryBaseService(param,
              function (response) {
                  if (response.success) {
                      getSecondaryCrewBaseAssignmentData();

                      vm.crewSecondaryBasePopOver = {popOverFlag : false};
                      vm.model.lastCrewSecondaryBaseOpenPopOver= {popOverFlag : false};
                      vm.model.newCrewSecondaryBasePopover={popOverFlag : false};

                      MessageService.success(MessageService.MESSAGES.CREW_PROFILE.DELETE_SUCCESS);
                  }
              },
              function (error) {
                  MessageService.error(error);
              }
          );
      };


      vm.deleteDateRangeController = function (positionDateRangeDTO) {
        var param = {};
        param.crewProfManagePosId = positionDateRangeDTO.crewProfManagePosId;
        param.crewProfileId = vm.model.crewDetails.crewProfileId;
        param.managementPosCode = positionDateRangeDTO.crewPosition.crewPositionCode;
        param.startDate = positionDateRangeDTO.dateOfStart;
        param.endDate = positionDateRangeDTO.dateOfEnd;
        param.version = -1;

        ProfileService.deleteDateRangeService(param,
          function (response) {
            if (response.success) {
              searchProfileDetailAfterPositionUpdate(vm.model.crewDetails.crewId);

              vm.dateRangePopOver = {popOverFlag : false};
              vm.model.lastDateRangeOpenPopOver= {popOverFlag : false};
              vm.model.newDateRangePopover={popOverFlag : false};

              MessageService.success(MessageService.MESSAGES.CREW_PROFILE.DELETE_SUCCESS);
            }
          },
          function (error) {
            MessageService.error(error);
          }
        );
      };

        vm.openCrewBaseHistoryController = function () {
            var param = {};
            param.crewProfileId = vm.model.crewDetails.crewProfileId;

            PopupManager.openModal('CREW_BASE_HISTORY', param, onSendAlertClose);
        };

        vm.openCrewPreferenceHistoryController = function () {
            var param = {};
            param.crewProfileId = vm.model.crewDetails.crewProfileId;

            PopupManager.openModal('CREW_PREFERENCE_HISTORY', param, onSendAlertClose);
        };
        vm.openCrewSecondaryBaseHistoryController = function () {
            var param = {};
            param.crewProfileId = vm.model.crewDetails.crewProfileId;

            PopupManager.openModal('CREW_SECONDARY_BASE_HISTORY', param, onSendAlertClose);
        };


        vm.openCrewACMIOperationsHistoryController = function () {
          var param = {};
          param.crewProfileId = vm.model.crewDetails.crewProfileId;
          param.onlyEffectiveRanges = false;

          PopupManager.openModal('CREW_ACMI_OPS_HISTORY', param, onSendAlertClose);
        };


      function onSendAlertClose() {
        }

        function clearOtherHubDetails(){
        	EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.CLEAR);
        }

        function searchCrewProfileById(crewId) {
        	var postData = {crewID : crewId};
            ProfileService.searchCrewProfile(postData,
                function (response) {
                    vm.model.createNewProfile = false;
                    vm.model.crewDetails = response;
                    loadCrewLanguageSkills();
                    getFleetExperience();
                    //getCrewPaymentDetails();
                    getCrewPaymentRangeDetails();
                    getCrewOtherPaymentDetails();
                    getCrewUpgradeData();
                    getCrewTrainingStages();
                    getCrewBaseAssignmentData();
                    getSecondaryCrewBaseAssignmentData();
                    searchCrewExclusion();
                    searchAirportExclusion();
                    searchAirportInclusion();
                    loadUseImgUrl();
                    getDefaultValidations(vm.model.crewDetails.crewProfileId);
                    loadCrewList(vm.model.crewDetails.crewTypeCode, vm.model.crewDetails.crewProfileId);
                    getAlvGroups(vm.model.crewDetails.crewTypeCode);
                    getCrewACMIEffectiveRanges();
                    resetCrewAirportRecencyData();
                    loadAssignedBatches();
                    getCrewLayoverAccommodationPreferences();

                    vm.model.actualScheduleSearchParam = crewScheduleService.adaptStateParams(vm.model.searchParam);
                    vm.model.actualScheduleSearchParam.crewIds = vm.model.searchParam.crewID;

                    vm.model.searchDetails = angular.copy(vm.model.searchParam);

                    generateCalendar();
                    loadActualSchedule();
                    clearOtherHubDetails();
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function searchCrewProfile() {
            ProfileService.searchCrewProfile(vm.model.searchParam,
                function (response) {
                    vm.model.createNewProfile = false;
                    vm.model.crewDetails = response;
                  getAirportList()
                    loadCrewLanguageSkills();
                    getFleetExperience();
                    //getCrewPaymentDetails();
                    getCrewPaymentRangeDetails();
                    getCrewOtherPaymentDetails();
                    getCrewUpgradeData();
                    getCrewTrainingStages();
                    getCrewBaseAssignmentData();
                    getSecondaryCrewBaseAssignmentData();
                    searchCrewExclusion();
                    searchAirportExclusion();
                    searchAirportInclusion();
                    loadUseImgUrl();
                    getDefaultValidations(vm.model.crewDetails.crewProfileId);
                    loadCrewList(vm.model.crewDetails.crewTypeCode, true, vm.model.crewDetails.crewProfileId);
                    getAlvGroups(vm.model.crewDetails.crewTypeCode);
                    resetCrewAirportRecencyData();
                    loadAssignedBatches();

                    getCrewLayoverAccommodationPreferences();
                    vm.model.actualScheduleSearchParam = crewScheduleService.adaptStateParams(vm.model.searchParam);
                    vm.model.actualScheduleSearchParam.crewIds = vm.model.searchParam.crewID;

                    vm.model.searchDetails = angular.copy(vm.model.searchParam);

                    generateCalendar();
                    loadActualSchedule();
                    clearOtherHubDetails();
                    getCrewACMIEffectiveRanges();
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function getDefaultValidations(crewProfileId) {
            ProfileService.getCrewDefaultValidation(crewProfileId, function (defaultValidations) {
                    vm.model.defaultValidations = defaultValidations;
                },
                function (error) {
                    MessageService.error(error);
                })
        }

        function loadCrewLanguageSkills() {
            ProfileService.searchCrewLanguageSkills(vm.model.crewDetails.crewProfileId,
                function (response) {
                    vm.model.crewLanguageSkills = response;
                    removeLanguageSkillsFromMasterList(vm.model.crewLanguageSkills);
                },
                function (error) {
                    console.log('Crew Language skill retrieval error');
                }
            );
        }


        function getFleetExperience() {
            ProfileService.getFleetExperience(vm.model.crewDetails.crewProfileId,
                function (response) {
                    vm.model.fleetExperienceDetails = addPopoverflag(response);
                },
                function (error) {
                    console.log('Crew Fleet Experience retrieval error');
                }
            );
        }

        function getCrewPaymentDetails() {
            ProfileService.getCrewPaymentDetails(vm.model.crewDetails.crewProfileId,
                function (response) {
                    if (!!response) {
                        vm.model.paymentDetails = response;
                        vm.model.paymentDetails.crewProfileId = vm.model.crewDetails.crewProfileId;
                    }
                },
                function (error) {
                    console.log('Crew payment details retrieval error');
                }
            );
        };

        function getCrewPaymentRangeDetails() {
            ProfileService.getCrewPaymentRangeDetails(vm.model.crewDetails.crewProfileId,
                function (response) {
                    if (!!response) {
                        vm.model.crewPaymentRangeDetails = response.paymentHourRangeDTOs;
                    }
                },
                function (error) {
                    console.log('Crew Payment  Range Details Retrieval Error');
                }
            );
        };

        function getCrewOtherPaymentDetails() {
            ProfileService.getCrewOtherPaymentDetails(vm.model.crewDetails.crewProfileId,
                function (response) {
                    if (!!response) {
                        vm.model.crewOtherPaymentDetails = crewProfileDTOFactory.setCrewOtherPaymentDetail(response.paymentRateCrewDTO);
                        EventManagerService.notifyEventListeners(
            					EventManagerService.EVENT.CREW_PAYMENT_RATES.REFRESH_OTHER_PAYMENT,
            					true);
                    }
                },
                function (error) {
                    console.log('Crew Other Payment Details Retrieval Error');
                }
            );
        };

        vm.saveFlyingHoursDetail = function(param) {
        	if(!!param){
        		var req = crewProfileDTOFactory.setFlyRangePaymentDetail(param);
    			ProfileService.saveCrewPaymentRangeDetails(req, function(response) {
    				if (response.success) {
    					getCrewPaymentRangeDetails(req.crewProfileId);
    					PopupManager.closeModal('ADD_CREW_FLYING_HOURS_RANGE');
    					MessageService.success("Payment Range saved successfully");
    				} else {
    					MessageService.error(errors[0]);
    				}
    			}, function(error) {
    				MessageService.error(error);
    			});
        	}
		};

        vm.saveOtherPaymentDetail = function(param) {
			if(!!param){
				var req = {
						otherPaymentRateDto : crewProfileDTOFactory.setCrewOtherPaymentDetailRQ(param)
						};

				ProfileService.saveCrewOtherPaymentRates(req,
						function(response) {
					if (response.success) {
						getCrewOtherPaymentDetails(param.crewProfileId);
						MessageService.success("Payment Rates saved successfully");
					} else {
						MessageService.error(errors[0]);
					}
				}, function(error) {
					MessageService.error(error);
				});
			}
		};

		vm.deleteFlyingHoursDetail = function(param) {
			var details = {
				title : 'Confirmation',
				messages : [ MessageService.MESSAGES.PAYMENT_RATES.DELETE_CONFIRMATION ]
			};
			PopupManager.closeModal('ADD_CREW_FLYING_HOURS_RANGE');
			PopupManager.openModal('CONFIRM_DIALOG', details, confirmDailogue);

			function confirmDailogue(pass) {
				if (pass == 'YES') {
					var req =  crewProfileDTOFactory.setFlyRangePaymentDeleteRq(param);
					ProfileService
							.deleteCrewFlyingHourRates(
									req,
									function(response) {
										if (response.success) {
											getCrewPaymentRangeDetails(param.crewProfileId);
											/*PopupManager
													.closeModal('ADD_CREW_FLYING_HOURS_RANGE');*/
											MessageService
													.success(MessageService.MESSAGES.PAYMENT_RATES.DELETE_SUCCESS);
										} else {
											openFlyingRangePopup(param);
											MessageService.error(errors[0]);
										}
									}, function(error) {
										openFlyingRangePopup(param);
										MessageService.error(error);
									});
				} else {
					MessageService
							.success(MessageService.MESSAGES.PAYMENT_RATES.DELETE_CANCEL);
					openFlyingRangePopup(param);
				}
			}
		};

		function openFlyingRangePopup(param){
			PopupManager.openModal(
					'ADD_CREW_FLYING_HOURS_RANGE', param,
					function() {
					});
		}

        function getCrewUpgradeData() {
            var param = {};
            param.crewProfileId = vm.model.crewDetails.crewProfileId;
            param.pageSize = -1;
            param.startPosition = 1;
            ProfileService.getCrewUpgradeData(param,
                function (response) {
                    vm.model.crewUpgradeData = addPopoverflag(response);
                },
                function (error) {
                    console.log('Crew upgrade data retrieval error')
                }
            );
        }

        function getCrewUpgradeData() {
          var param = {};
          param.crewProfileId = vm.model.crewDetails.crewProfileId;
          param.pageSize = -1;
          param.startPosition = 1;
          ProfileService.getCrewUpgradeData(param,
            function (response) {
              vm.model.crewUpgradeData = addPopoverflag(response);
            },
            function (error) {
              console.log('Crew upgrade data retrieval error')
            }
          );
        }

        function groupCrewTrainingStages(response) {
          // Process data to group by crewTypeStageId
          var stage_index = 1;
          var groupedData = Object.values(
            response.reduce(function (acc, item) {
              if (!acc[item.crewTypeStageId]) {
                acc[item.crewTypeStageId] = {
                  key: stage_index++,
                  crewTypeStageId: item.crewTypeStageId,
                  stageSequenceOrder: item.stageSequenceOrder,
                  stageName: item.stageName,
                  crewTypeCode: item.crewTypeCode,
                  status: item.status,
                  stageVersion: item.stageVersion,
                  isStageCompleted: item.isStageCompleted,
                  stageUpgradedDate: item.isStageCompleted === 'Y' && item.stageUpgradedDateUnix ? moment(item.stageUpgradedDateUnix).format('DD/MM/YYYY') : null,
                  instructors: [],
                  instructorsDataList: [],
                };
              }

              // Group by sequence order and combine instructor types
              var existingInstructor = acc[item.crewTypeStageId].instructorsDataList.find(function (instructor) {
                return instructor.instructorSequenceOrder === item.instructorSequenceOrder;
              });

              if (existingInstructor) {
                existingInstructor.instructorTypeCodes.push(item.instructorTypeCode);
              } else {
                acc[item.crewTypeStageId].instructorsDataList.push({
                  instructorSequenceOrder: item.instructorSequenceOrder,
                  instructorTypeCodes: [item.instructorTypeCode],
                  sectorCount: item.sectorCount,
                  instructorTypeCodeVersion: item.instructorTypeCodeVersion,
                  isOrder: item.isOrder,
                });
              }

              return acc;
            }, {})
          );

          // Add instructors as a single string with line breaks and comma-separated instructor types
          var tableData = groupedData.map(function (item) {
            return Object.assign({}, item, {
              instructors: item.instructorsDataList
                .map(function (instructor) {
                  return instructor.instructorTypeCodes.join(", ") +
                    " / " + instructor.sectorCount +
                    " / " + (instructor.isOrder === "Y" ? instructor.instructorSequenceOrder : '');
                })
                .join("\n"),
            });
          });
          return tableData;
        }

      vm.updateTrainingStageStatus = function (trainingStageStatusUpdateRequest, trainingStage, isStageCompleted) {
        // Find the corresponding stage in $ctrl.crewTrainingStages
        var matchingStage = vm.model.crewTrainingStages.find(function(stage) {
          return stage.crewTypeStageId === trainingStage.crewTypeStageId;
        });

        ProfileService.updateTrainingStageStatus(trainingStageStatusUpdateRequest,
          function (response) {
            if (response.success){
              MessageService.success(MessageService.MESSAGES.CREW_PROFILE.TRAINING_STAGE_COMPLETION_UPDATE_SUCCESS);
            } else if(response.errors && response.errors.length > 0) {
              MessageService.error(response.errors[0]);
            }
            getCrewTrainingStages();
          },
          function (error) {
            console.log("Training Stage Status Update failed:", error);
            MessageService.error(MessageService.MESSAGES.CREW_PROFILE.TRAINING_STAGE_COMPLETION_UPDATE_FAILED);
            getCrewTrainingStages();
          }
        );
      }

      function addCheckboxStates(stages) {
        // Sort stages by sequence order to ensure proper ordering
        var sortedStages = stages.sort(function(a, b) {
          return a.stageSequenceOrder - b.stageSequenceOrder;
        });

        var lastCompletedIndex = -1;

        // Find the last completed stage
        for (var i = 0; i < sortedStages.length; i++) {
          if (sortedStages[i].isStageCompleted === 'Y') {
            lastCompletedIndex = i;
          }
        }

        // Apply checkbox states
        for (var j = 0; j < sortedStages.length; j++) {
          var stage = sortedStages[j];

          if (stage.isStageCompleted === 'Y') {
            // Completed stages
            if (j === lastCompletedIndex) {
              // Latest completed stage - can be unchecked (disabled = false)
              stage.checkboxDisabled = false;
              stage.canToggle = true;
            } else {
              // Previous completed stages - cannot be unchecked (disabled = true)
              stage.checkboxDisabled = true;
              stage.canToggle = false;
            }
            stage.isChecked = true;
          } else {
            // Incomplete stages
            if (j === lastCompletedIndex + 1) {
              // Next stage after last completed - can be checked
              stage.checkboxDisabled = false;
              stage.canToggle = true;
            } else {
              // Future stages - cannot be checked yet
              stage.checkboxDisabled = true;
              stage.canToggle = false;
            }
            stage.isChecked = false;
          }
        }

        return sortedStages;
      }

      function getCrewTrainingStages() {
          var param = {};
          param.crewProfileId = vm.model.crewDetails.crewProfileId;
          param.crewTypeCode = vm.model.crewDetails.crewTypeCode;
          param.status = 'ACT';

          ProfileService.getCrewTrainingStages(param,
            function (response) {
              var groupedData = groupCrewTrainingStages(response);
              var processedData = addCheckboxStates(groupedData);
              vm.model.crewTrainingStages = addPopoverflag(processedData);

            },
            function (error) {
              console.log('Crew upgrade data retrieval error')
            }
          );
        }


      function getCrewAirportRecencyDate() {
        var param = {};
        param.crewProfileId = vm.model.crewDetails.crewProfileId;

        ProfileService.getCrewAirportRecencyData(param,
          function (response) {
            vm.model.crewAirportRecency=response.airportRecencyDTOList;
            vm.model.airportRecencyLastRefreshTime = moment().format('YYYY-MM-DD HH:mm:ss');
          },
          function (error) {
            console.log('Airport Recency data retrieval error')
          }
        );
      }

      // Airport recency is loaded lazily when the Airport Recency tab is opened
      function resetCrewAirportRecencyData() {
        vm.model.crewAirportRecency = [];
        vm.model.airportRecencyLastRefreshTime = null;
      }

      function getCrewLayoverAccommodationPreferences() {
        var param = {};
        param.crewProfileId = vm.model.crewDetails.crewProfileId;

        ProfileService.getCrewLayoverAccommodationPreferences(param,
          function (response) {
            vm.model.crewLayoverAccommodationPreferences=response.crewLayoverAccommodationPreferenceDTOList;
          },
          function (error) {
            console.log('Crew Layover Accommodation Preference data retrieval error');
          }
        );
      }

      vm.refreshAirportRecencyData = function() {
        getCrewAirportRecencyDate();
      };

      vm.addNewLayoverAccommodationPreference = function() {
        var modelParam = {};
        vm.model.selectedRow = crewProfileDTOFactory.preferenceDataDTO();
        vm.model.selectedRow.crewProfileId = vm.model.crewDetails.crewProfileId;
        modelParam.selectedRow = vm.model.selectedRow;
        modelParam.masterList = {
          stations : vm.model.airports
        }
        PopupManager.openModal('LAYOVER_ACCOMMODATION_PREFERENCE_EDIT_POPUP',
            modelParam, onModalClose);
      };

      vm.editLayoverAccommodationPreference = function(selectedRow) {
        var modelParam = {};
        vm.model.selectedRow = selectedRow;
        vm.model.selectedRow.crewProfileId = vm.model.crewDetails.crewProfileId;
        modelParam.selectedRow = vm.model.selectedRow;
        modelParam.masterList = {
          stations : vm.model.airports
        }
        PopupManager.openModal('LAYOVER_ACCOMMODATION_PREFERENCE_EDIT_POPUP',
            modelParam, onModalClose);
      };

      vm.deleteLayoverAccommodationPreference = function(selectedRow) {
        vm.model.selectedRow = selectedRow;
        if (vm.model.selectedRow == null) {
          MessageService
              .error('Please select a record to Delete');
        } else {
          var details = {
            title : 'Confirmation',
            messages : [ MessageService.MESSAGES.LAYOVER_ACCOMMODATION_PREFERENCE.DELETE_CONFIRMATION ]
          };
          PopupManager.openModal('CONFIRM_DIALOG',
              details, confirmDeletion);
        }
      };

      function confirmDeletion(pass) {
        if (pass == 'YES') {
          var param = getSavePreferenceRequest(vm.model.selectedRow);
          ProfileService
              .deletePreferenceData(
                  param,
                  function(response) {
                    if (response.success) {
                      MessageService
                          .success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                      getCrewLayoverAccommodationPreferences();
                    }
                  }, function(error) {
                    MessageService.error(error);
                  });
        }
      }

      function getSavePreferenceRequest(preferenceDTO) {
        var req = {};
        req.fromDate = preferenceDTO.fromDate;
        req.toDate = preferenceDTO.toDate;
        req.station = preferenceDTO.station.airPortCode;
        req.remarks = preferenceDTO.remarks;
        req.crewProfileId = preferenceDTO.crewProfileId;
        req.crewLayoverAccommodationPrefId = preferenceDTO.crewLayoverAccommodationPrefId;
        req.version = preferenceDTO.version;
        return req;
      }

      function onModalClose() {
        getCrewLayoverAccommodationPreferences();
      }

      function getCrewBaseAssignmentData() {
            var param = {};
            param.crewProfileId = vm.model.crewDetails.crewProfileId;
            ProfileService.getCrewBaseAssignmentData(param,
                function (response) {
                    vm.model.crewBaseAssignments = addPopoverflag(response);
                },
                function (error) {
                    console.log('Crew base assignment data retrieval error')
                }
            );
        }

      function getSecondaryCrewBaseAssignmentData() {
          var param = {};
          param.crewProfileId = vm.model.crewDetails.crewProfileId;
          param.primary = false;
          ProfileService.getCrewBaseAssignmentData(param,
              function (response) {
                  vm.model.secondaryCrewBaseAssignments = addPopoverflag(response);
              },
              function (error) {
                  console.log('Secondary Crew base assignment data retrieval error')
              }
          );
      }

      function updateCrewBaseConfirmation(details,baseList,startDate,endDate) {
        vm.selectedBase=details;
        var MESSAGES=[];
        if(baseList.length>0){
          var baseListStr = baseList.join(', ');
          if(endDate != null){
            MESSAGES=["There are duties assigned in " + baseListStr + " base(s) from "+ startDate + " to " + endDate + ". Are you sure to continue?"];
          }else{
            MESSAGES=["There are duties assigned in " + baseListStr + " base(s) from "+ startDate + ". Are you sure to continue?"];
          }

        }else{
          if(endDate != null){
            MESSAGES=["No duties assigned in other bases between "+ startDate +" - " + endDate + ". Proceed?"];
          }else{
            MESSAGES=["No duties assigned in other bases from "+ startDate +". Proceed?"];
          }

        }
        var details = {
          title: 'Confirmation',
          messages: MESSAGES
        };
        PopupManager.openModal('CONFIRM_DIALOG', details, confirmBaseUpdate);
      }

      function confirmBaseUpdate(pass){
        if(pass=='YES') {
          vm.addEditCrewBase();
        }
      }

       vm.getEffectedBaseList = function (crewBaseDTO){
            var param = {};
            param.crewBaseAssignmentId = crewBaseDTO.crewBaseAssignmentId;
            param.crewProfileId = vm.model.crewDetails.crewProfileId;
            param.effectiveFromDate = crewBaseDTO.effectiveFromDate;
            param.base = crewBaseDTO.crewBase.airPortCode;
            param.version = crewBaseDTO.version;
            param.joinedDate=crewBaseDTO.joinedDate;
            param.updateType=crewBaseDTO.updateType;
            param.employerHub = crewBaseDTO.employerHub.hubCode;
            param.postingType = crewBaseDTO.postingType.value;
            param.remarks = crewBaseDTO.remarks;

            vm.crewBasePopOver.crewBaseAssignmentId = crewBaseDTO.crewBaseAssignmentId;
            vm.crewBasePopOver.crewProfileId = vm.model.crewDetails.crewProfileId;
            vm.crewBasePopOver.effectiveFromDate = crewBaseDTO.effectiveFromDate;
            vm.crewBasePopOver.crewBase = crewBaseDTO.crewBase;
            vm.crewBasePopOver.version = crewBaseDTO.version;
            vm.crewBasePopOver.joinedDate=crewBaseDTO.joinedDate;
            vm.crewBasePopOver.updateType=crewBaseDTO.updateType;
            vm.crewBasePopOver.employerHub = crewBaseDTO.employerHub;
            vm.crewBasePopOver.postingType = crewBaseDTO.postingType ? vm.crewBasePopOver.postingType: null;
            vm.crewBasePopOver.remarks = crewBaseDTO.remarks;

            ProfileService.getEffectedBaseList(param,
                function (response) {
                    console.log(response);
                    console.log("crewprofctrl");
                    vm.model.effectedBaseList = response.baseList;
                    updateCrewBaseConfirmation(vm.crewBasePopOver,vm.model.effectedBaseList,response.startDate,response.endDate)

                },
                function (error) {
                    console.log('Base assignments to be updated data retrieval error')
                }
            );
        }
      function updateCrewBaseConfirmation(details,baseList,startDate,endDate) {
        vm.selectedBase=details;
        var MESSAGES=[];
        if(baseList.length>0){
          var baseListStr = baseList.join(', ');
          if(endDate != null){
            MESSAGES=["There are duties assigned in " + baseListStr + " base(s) from "+ startDate + " to " + endDate + ". Are you sure to continue?"];
          }else{
            MESSAGES=["There are duties assigned in " + baseListStr + " base(s) from "+ startDate + ". Are you sure to continue?"];
          }

        }else{
          if(endDate != null){
            MESSAGES=["No duties assigned in other bases between "+ startDate +" - " + endDate + ". Proceed?"];
          }else{
            MESSAGES=["No duties assigned in other bases from "+ startDate +". Proceed?"];
          }

        }
        var details = {
          title: 'Confirmation',
          messages: MESSAGES
        };
        PopupManager.openModal('CONFIRM_DIALOG', details, confirmBaseUpdate);
      }

      function confirmBaseUpdate(pass){
        if(pass=='YES') {
          vm.addEditCrewBase();
        }
      }


      function searchProfileDetailAfterPositionUpdate(searchParam) {
          SlideInPanelService.closeAllPanels();
          vm.model.dobAfterToday = false;
          vm.model.passportIssuedDateAfterToday = false;
          vm.model.searchParam.fromDate = vm.fromDate;
          vm.model.searchParam.toDate = vm.toDate;
          vm.model.searchParam.crewId = searchParam;
          vm.model.searchParam.crewID = searchParam;

          vm.model.actualScheduleSearchParam = crewScheduleService.adaptStateParams(vm.model.searchParam);
          vm.model.actualScheduleSearchParam.crewIds = searchParam;

          vm.model.searchDetails = angular.copy(vm.model.searchParam);//vm.model.search

          vm.model.showSearchArea = false;

          CommonMasterData.model.languageList = null;
          getLanguageList();

          searchCrewProfile();

      }


        function addPopoverflag(crewUpgradeData) {
            _.each(crewUpgradeData, function (obj) {
                obj.popOverFlag = false;
            });
            return crewUpgradeData;
        }

        function searchCrewExclusion() {
            var param = {};
            param.crewProfId = vm.model.crewDetails.crewProfileId;
            param.isActive = true;
            ProfileService.searchCrewExclusion(param,
                function (response) {
                    vm.model.crewExclusion = adaptCrewExclusion(response);
                },
                function (error) {
                    console.log('Crew exclusion data retrieval error')
                }
            );
        }

      function adaptCrewExclusion(crewExclusion) {
		    var list = [];

		    angular.forEach(crewExclusion,function (crew) {
          var childNode = new MultiSelectNode();
          childNode.valueFieldName = crew.excludedCrewProfileId;
          childNode.labelFieldName = crew.crewName;
          childNode.startedDate = crew.exclusionStartDate;
          list.push(childNode);
        })

        return list;

      }

        function searchAirportExclusion() {
            ProfileService.searchAirportExclusion(vm.model.crewDetails.crewProfileId,
                function (response) {
                  vm.model.airportExclusion = adaptAirportExclusion(response);

                },
                function (error) {
                    console.log('Crew airport exclusion retrieval error');
                }
            );
        }

      function adaptAirportExclusion(airportExclusions) {
        var list = [];

        angular.forEach(airportExclusions,function (airport) {
          var childNode = new MultiSelectNode();
          childNode.valueFieldName = airport.airportCode;
          childNode.labelFieldName = airport.airportCode;
          childNode.startedDate = airport.exclusionStartDate;
          list.push(childNode);
        })

        return list;

      }

      function searchAirportInclusion() {
        ProfileService.searchAirportInclusion(vm.model.crewDetails.crewProfileId,
          function (response) {
            vm.model.airportInclusion = adaptAirportInclusion(response);
          },
          function (error) {
            console.log('Crew airport inclusion retrieval error');
          }
        );
      }

      function adaptAirportInclusion(airportInclusions) {
        var airportInclusionsList = [];
        angular.forEach(airportInclusions,function (airport) {
          var childNode = new MultiSelectNode();
          childNode.valueFieldName = airport.airportCode;
          childNode.labelFieldName = airport.airportCode;
          childNode.startedDate = airport.inclusionStartDate;
          airportInclusionsList.push(childNode);
        })
        return airportInclusionsList;
      }

        function getTrainerTypes() {
            ProfileService.getTrainerTypes(
                function (response) {
                    vm.model.trainerTypes = response;
                    var trainerTypesForTrainingStages = angular.copy(response);
                    trainerTypesForTrainingStages.push({
                      trainerTypeCode: 'Any',
                    });
                    vm.model.trainerTypesForTrainingStages = trainerTypesForTrainingStages;
                },
                function (error) {
                    console.log('Crew Trainer type retrieval error');
                }
            );
        }

        function getAlvGroups(crewType) {
          ProfileService.getAlvGroups(crewType,
            function (response) {
              vm.model.alvGroups = response;
            },
            function (error) {
              console.log('ALV groups retrieval error');
            }
          );
        }

        function setDefaultPassword(crewTypeCode) {


              vm.model.isWebAccessInfo = true;
              vm.model.webAccessInfoDTO = vm.model.webAccessInfoDTO || {};

              for (var i = 0; i < vm.model.defaultPasswordsList.length; i++) {
                  if (vm.model.defaultPasswordsList[i].crewType === crewTypeCode) {
                      // Default password (must satisfy your regex)

                      vm.model.webAccessInfoDTO.password = vm.model.defaultPasswordsList[i].password;
                      vm.model.webAccessInfoDTO.confirmPassword = vm.model.defaultPasswordsList[i].password;
                      break;
                  }
              }


          }


        function loadUseImgUrl() {
            window.setTimeout(loadCrewProfileImage, 2000);
            // crewScheduleService.loadCrewImageURL(vm.model.crewDetails.crewProfileId,
            //     function (response) {
            //         vm.model.imageUrl = '../images/profile-img.jpg';
            //         vm.model.imageUrl = response+'?lastmod='+new Date().getTime();
            //         if (vm.model.imageUrl === null) {
            //             vm.model.imageUrl = '../images/profile-img.jpg';
            //         }
            //     },
            //     function (error) {
            //     }
            // );
        }

        function loadCrewProfileImage(){
          crewScheduleService.loadCrewImageURL(vm.model.crewDetails.crewProfileId,
            function (response) {
              // vm.model.imageUrl = '../images/profile-img.jpg';
              // vm.model.imageUrl = response+'?lastmod='+new Date().getTime();
              vm.model.imageUrl = response;
              if (vm.model.imageUrl === null) {
                vm.model.imageUrl = '../images/profile-img.jpg';
              }
            },
            function (error) {
              vm.model.imageUrl = '../images/profile-img.jpg';
            }
          );
        }


        vm.editSaveProfile = function () {
            editSaveCrewProfile();
        };

        function editSaveCrewProfile() {
            ProfileService.editSaveCrewProfile(vm.model.crewDetails,
                function (response) {
                    MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                    vm.model.createNewProfile = false;
                    if (vm.model.crewDetails.crewId) {
                    	searchCrewProfileById(vm.model.crewDetails.crewId);
                    }

                },
                function (error) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_PROFILE.EDIT_FAIL);
                    MessageService.error(error);
                }
            );
        };

        vm.addDeleteLanguageSkill = function () {
            ProfileService.addDeleteExclusion(vm.model.crewDetails.crewProfileId, vm.model.crewLanguageSkills, 'language',
                function (response) {
                    MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };
        vm.saveAddEditExclusion = function (exclusionDTO, confirmed) {
          ProfileService.addDeleteExclusion(vm.model.crewDetails.crewProfileId, exclusionDTO, 'other',
            function (response) {

              // Pre-check returned violations — show confirmation dialog before saving
              if (response.requiresConfirmation) {
                var violatedCrewDisplayNameList = [];
                angular.forEach(response.violatedBlocks, function (block) {
                  if (block.crewName) {
                    violatedCrewDisplayNameList.push(block.crewName);
                  }
                });
                // fall back to raw IDs resolved against allCrewList
                if (violatedCrewDisplayNameList.length === 0) {
                  angular.forEach(vm.model.allCrewList, function (crew) {
                    angular.forEach(response.violatedCrewList, function (violatedCrew) {
                      if (crew.crewProfileId == violatedCrew)
                        violatedCrewDisplayNameList.push(crew.displayName);
                    });
                  });
                }
                var details = {
                  violatedAirportList: response.violatedAirportList || [],
                  violatedCrewList: violatedCrewDisplayNameList
                };
                PopupManager.openModal('SHOW_EXCLUSION_VIOLATION', details, function (result) {
                  if (result === 'CONFIRM') {
                    vm.saveAddEditExclusion(exclusionDTO, true);
                  }
                });
                return;
              }

              // Save succeeded — show post-save violation info if any remain
              MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
              if (response.violatedAirportList && response.violatedCrewList &&
                  (response.violatedAirportList.length > 0 || response.violatedCrewList.length > 0)) {
                var violatedCrewDisplayNameList = [];
                angular.forEach(vm.model.allCrewList, function (crew) {
                  angular.forEach(response.violatedCrewList, function (violatedCrew) {
                    if (crew.crewProfileId == violatedCrew)
                      violatedCrewDisplayNameList.push(crew.displayName);
                  });
                });
                var details = {
                  violatedAirportList: response.violatedAirportList,
                  violatedCrewList: violatedCrewDisplayNameList,
                  infoOnly: true
                };
                PopupManager.openModal('SHOW_EXCLUSION_VIOLATION', details, function(){});
              }

            },
            function (error) {
              MessageService.error(error);
            },
            confirmed === true
          );
        };

        vm.saveAddEditInclusion = function (inclusionDTO) {
          function doSave(confirmed) {
            ProfileService.addDeleteInclusion(vm.model.crewDetails.crewProfileId, inclusionDTO,
              function (response) {
                if (response.requiresConfirmation) {
                  var details = {
                    violatedAirportList: response.affectedAirports || [],
                    violatedCrewList: [],
                    infoOnly: false,
                    isInclusion: true
                  };
                  PopupManager.openModal('SHOW_EXCLUSION_VIOLATION', details, function (result) {
                    if (result === 'CONFIRM') {
                      doSave(true);
                    }
                  });
                  return;
                }

                MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);

                if (response.infoOnly && response.affectedAirports && response.affectedAirports.length > 0) {
                  var infoDetails = {
                    violatedAirportList: response.affectedAirports,
                    violatedCrewList: [],
                    infoOnly: true,
                    isInclusion: true
                  };
                  PopupManager.openModal('SHOW_EXCLUSION_VIOLATION', infoDetails, function () {});
                }
              },
              function (error) {
                MessageService.error(error);
              },
              confirmed === true
            );
          }
          doSave(false);
        };

        vm.updatePaymentInfo = function () {
            ProfileService.updatePaymentInfo(vm.model.paymentDetails,
                function (response) {
            		EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_PROFILE.PAYMENT_EDIT_STATE_CHANGE);
	            	vm.model.paymentDetails = response.paymentRateDTO;
	                vm.model.paymentDetails.crewProfileId = vm.model.crewDetails.crewProfileId;
                    MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        vm.addEditTrainingStage = function (trainingStageDTO) {
          ProfileService.addEditTrainingStage(trainingStageDTO,
            function (response) {
              if (response.success) {
                getCrewTrainingStages();
                MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                angular.element(".add-box").trigger('click');
              }

            },
            function (error) {
              MessageService.error(error);
            }
          );

        };

        vm.addEditCrewUpgrade = function (upgradeDTO) {
            var param = {};
            param.crewProfileId = vm.model.crewDetails.crewProfileId;
            param.updateType=upgradeDTO.updateType.toUpperCase();
            if (upgradeDTO.updateType.toUpperCase() === 'EDIT') {
                param.crewProfileUpgradeId = upgradeDTO.crewProfileUpgradeId;
            } else {
                param.crewProfileUpgradeId = null;
            }
            param.crewTypeCode = upgradeDTO.crewTypeDetails.crewTypeCode;
            param.dateOfUpgrade = upgradeDTO.localDateTime;
            param.dateOfJoin=upgradeDTO.dateOfJoin;
            param.crewProfCrewTypeChanged = upgradeDTO.crewProfCrewTypeChanged;
            param.version = upgradeDTO.version;


            ProfileService.addEditCrewUpgrade(param,
                function (response) {
                    if (response.success) {
                        getCrewUpgradeData();
                        MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                        angular.element(".add-box").trigger('click');
                    }

                },
                function (error) {
                    MessageService.error(error);
                }
            );

        };

        vm.deleteCrewUpgrade = function (upgradeDTO) {

            if (upgradeDTO.updateType.toUpperCase() === 'EDIT') {
            	var param = {};
            	param.crewProfileId = vm.model.crewDetails.crewProfileId;
                param.crewProfileUpgradeId = upgradeDTO.crewProfileUpgradeId;
                param.crewTypeCode = upgradeDTO.crewTypeDetails.crewTypeCode;
                param.previousCrewType = !!upgradeDTO.previousCrewType ? upgradeDTO.previousCrewType : upgradeDTO.crewTypeDetails.crewTypeCode;
                param.dateOfJoin = upgradeDTO.localDateTime;
                param.version = upgradeDTO.version;

                ProfileService.deleteCrewUpgrade(param,
                    function (response) {
                        if (response.success) {
                            getCrewUpgradeData();
                            MessageService.success(MessageService.MESSAGES.CREW_PROFILE.DELETE_SUCCESS);
                        }else{
                        	MessageService.error(response.errors[0]);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }


        };

        function loadCrewListWithoutLimit() {
            var param = {};
            param.crewType = '';
            param.active = true;

            CommonMasterData.loadCrewList(param,
                function (response) {
                    vm.model.allCrewList = crewScheduleService.adaptCrewList(response);
                    vm.model.crewTypeWiseNameList = crewGroupByCrewType();
                  console.log("vm.model.crewTypeWiseNameList:",vm.model.crewTypeWiseNameList)
                  console.log("vm.model.countryNameWiseAirportList:",vm.model.countryNameWiseAirportList)
                },
                function () {
                    console.log('Crew list retrieval error');
                }
            );
        }

        function crewGroupByCrewType() {
          var crewGrouping = _.groupBy(vm.model.allCrewList, 'crewType');
          var list = [];
          angular.forEach(crewGrouping, function(group,key){
            var parentNode = new MultiSelectNode();
            parentNode.labelFieldName = key;
            parentNode.valueFieldName = key;
            var temp = [];
            angular.forEach(group, function(crew){
              var childNode = new MultiSelectNode();
              childNode.valueFieldName = crew.crewProfileId;
              childNode.labelFieldName = crew.displayName;
              temp.push(childNode);
            });
            parentNode.childElements = temp;
            list.push(parentNode);
          });
        return list;
      }

      function crewGroupByCrewTypeAfterSearch(crewProfileId) {
        var crewGrouping = _.groupBy(vm.model.allCrewList, 'crewType');
        var list = [];
        angular.forEach(crewGrouping, function(group,key){
          var parentNode = new MultiSelectNode();
          parentNode.labelFieldName = key;
          parentNode.valueFieldName = key;
          var temp = [];
          angular.forEach(group, function(crew){
            if (crew.crewProfileId !== crewProfileId) {
              var childNode = new MultiSelectNode();
              childNode.valueFieldName = crew.crewProfileId;
              childNode.labelFieldName = crew.displayName;
              temp.push(childNode);
            }
          });
          parentNode.childElements = temp;
          list.push(parentNode);
        });
        return list;
      }

      function airpotsByCountryName() {
        var airportGrouping = _.groupBy(vm.model.airports, 'countryName');
        var list = [];
        angular.forEach(airportGrouping, function(group,key){
          var parentNode = new MultiSelectNode();
          parentNode.labelFieldName = key;
          parentNode.valueFieldName = key;
          var temp = [];
          angular.forEach(group, function(airport){
            var childNode = new MultiSelectNode();
            childNode.valueFieldName = airport.airPortCode;
            childNode.labelFieldName = airport.airPortCode;
            temp.push(childNode);
          });
          parentNode.childElements = temp;
          list.push(parentNode);
        });
        return list;
      }

      vm.changeCreateProfileStatus = function () {
        vm.model.dobAfterToday = false;
        vm.model.passportIssuedDateAfterToday = false;
        vm.model.showSearchArea = false;
        vm.model.createNewProfile = !vm.model.createNewProfile;
        vm.model.crewLanguageSkills = [];
        CommonMasterData.model.languageList = null;
        getLanguageList();
        getDefaultPasswords();
        if (vm.model.createNewProfile) {
          loadUserRoles();
        }
        vm.model.searchCriteria = {
          nationality : null
        }

      };

        vm.saveNewCrew = function () {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CLICK_CREATE_PROFILE);
        };

        vm.crewNavigation = function (type) {
        	SlideInPanelService.closeAllPanels();
            var nextOptionCrewId = '';
            var getIndexBy = function () {
                for (var i = 0; i < vm.model.crewList.length; i++) {
                    if (vm.model.crewList[i].crewId === vm.model.crewDetails.crewId) {
                        return i;
                    }
                }
                return -1;
            };
            var currentIndex = getIndexBy();
            if (type === 'Next') {
                if (currentIndex === (vm.model.crewList.length - 1)) {
                    nextOptionCrewId = vm.model.crewList[0].crewId;
                }
                else {
                    nextOptionCrewId = vm.model.crewList[currentIndex + 1].crewId;
                }
            }
            else {
                if (currentIndex === 0) {
                    nextOptionCrewId = vm.model.crewList[vm.model.crewList.length - 1].crewId;
                }
                else {
                    nextOptionCrewId = vm.model.crewList[currentIndex - 1].crewId;
                }

            }
            var moStart = moment().startOf("month");
            var moEnd = moment().endOf("month");
            vm.fromDate = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);
            vm.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
            vm.model.searchParam.fromDate = vm.fromDate;
            vm.model.searchParam.toDate = vm.toDate;
            vm.model.searchParam.crewId = nextOptionCrewId;
            vm.model.searchParam.crewID = nextOptionCrewId;
            vm.model.searchDetails = angular.copy(vm.model.searchParam);
            vm.model.showSearchArea = false;

            vm.model.actualScheduleSearchParam = crewScheduleService.adaptStateParams(vm.model.searchParam);

            vm.model.searchDetails = angular.copy(vm.model.searchParam);//vm.model.search
            generateCalendar();
            loadActualSchedule();
            searchCrewProfile();
        };

        function initLoadingCrewProfile() {
            if (vm.model.searchParam.crewID) {
                searchCrewProfile()
            }
        }

        function init() {

            CommonMasterData.getCrewBaseList(function (baseList) {
                vm.model.baseList = baseList;
            }, function (error) {

            });

            // load ACMI types
            CommonMasterData.getACMITypesList(function (acmiTypes) {
                vm.model.acmiTypes = acmiTypes;
            }, function (error) {

            });

            initLoadingCrewProfile();
        }

        init();

        function generateCalendar() {
        	vm.calendar = [];
            vm.weekDays = moment.weekdaysShort(true);
            vm.cal_start = moment(vm.fromDate, "DD/MM/YYYY");
            vm.cal_end = moment(vm.toDate, 'DD/MM/YYYY');

            var month = vm.cal_start.format('MM');
            var year = vm.cal_start.format('YYYY');
            var calenderEnd = '';
            var calendarStart = moment('01/' + month + '/' + year, "DD/MM/YYYY");
            var monthEnd = moment(vm.cal_start).endOf('month');
            if (vm.cal_end.isAfter(monthEnd)) {
                calenderEnd = vm.cal_end;
            }
            else {
                calenderEnd = monthEnd;
            }

            var dateDiff = calenderEnd.diff(calendarStart, 'days');

            var tempCalendar = [];
            var currDate = moment().format("DD/MM/YYYY");
            for (var i = 0; i <= dateDiff; i++) {
                var tmp = moment(calendarStart).add(i, 'd');
                var isCurrentDate = (currDate === tmp.format('DD/MM/YYYY'));
                var isDisable = true;
                if (tmp.isBefore(vm.cal_end)
                    && tmp.isAfter(vm.cal_start)
                    || (tmp.isSame(vm.cal_start) || tmp.isSame(vm.cal_end))
                ) {
                    isDisable = false;
                }

                tempCalendar.push({
                    date: tmp.format('DD/MM/YYYY'),
                    dayReference: tmp.format('YYYYMMDD'),
                    isSelected: false,
                    actualSchedule: [],
                    publishSchedule: [],
                    alertDetails: [],
                    memoDetails: [],
                    expiry: [],
                    isCurrentDate: isCurrentDate,
                    dayIndex: i,
                    isDisable: isDisable

                });
            }

            var starIndex = vm.weekDays.indexOf(calendarStart.format('ddd'));
            if (starIndex !== 0) {
                for (var i = 0; i < starIndex; i++) {
                    tempCalendar.unshift({
                        date: 0,
                        dayReference: 0,
                        isSelected: false,
                        actualSchedule: [],
                        publishSchedule: [],
                        alertDetails: [],
                        memoDetails: [],
                        expiry: [],
                        isCurrentDate: false,
                        dayIndex: '',
                        isDisable: true

                    });
                }
            }
            var endIndex = vm.weekDays.indexOf(calenderEnd.format('ddd'));
            if (endIndex !== 6) {
                for (var j = 0; j < (6 - endIndex); j++) {
                    tempCalendar.push({
                        date: 0,
                        dayReference: 0,
                        isSelected: false,
                        actualSchedule: [],
                        publishSchedule: [],
                        alertDetails: [],
                        memoDetails: [],
                        expiry: [],
                        isCurrentDate: false,
                        dayIndex: '',
                        isDisable: true
                    });
                }
                var t = 0;
                vm.originalCal = angular.copy(tempCalendar)
                for (var k = 0; k < tempCalendar.length; k += 7) {
                    var temp = [];
                    var j = 0;
                    for (j; j < 7; j++) {
                        temp.nextWeekStart = '';
                        temp.rowIndex = t;
                        temp[temp.length] = tempCalendar[k + j];
                        if (j === 0 && k !== 0) {
                            vm.calendar[t].nextWeekStart = tempCalendar[k + j].date;
                            t = t + 1;
                        }
                    }
                    vm.calendar[vm.calendar.length] = temp
                }
                CrewingSelectionHelper.setTimeLineDaysCol(vm.calendar);
            }
        }

        vm.monthNavigationClicked = function(type){
            var monthStart , monthEnd,monthStartDate;
            if(type === 'Next'){
                monthStartDate = moment(vm.fromDate, "DD/MM/YYYY").add(1, 'month');
            }
            else{
                var preMonthStart , prevMonthEnd;
                monthStartDate = moment(vm.fromDate, "DD/MM/YYYY").subtract(1, 'month');
            }
            var month = monthStartDate.format('MM');
            var year = monthStartDate.format('YYYY');
            monthStart = '01/'+month+'/'+year;
            vm.fromDate = monthStart;
            var monthEndDate = moment(monthStart, "DD/MM/YYYY").endOf('month');
            monthEnd = monthEndDate.format("DD/MM/YYYY");
            vm.toDate = monthEnd;

            vm.model.searchDetails.fromDate = monthStart;
            vm.model.searchDetails.toDate = monthEnd;

            vm.model.actualScheduleSearchParam.fromDate = monthStart;
            vm.model.actualScheduleSearchParam.toDate = monthEnd;
            loadActualSchedule();

        };

        vm.reGenerateCalender = function(){
        	generateCalendar();
            loadActualSchedule();
        }

        function openMemoListener(memo) {
            var param = {};
            param.day = memo.memoDate;
            param.crewProfileId = vm.model.crewDTO.crewProfileId;
            param.crewId = vm.model.crewDTO.crewId;
            param.memo = memo;
            param.readOnly = (memo.memoCategoryCode=='RECENCY')?true:false;
            PopupManager.openModal('ADD_EDIT_MEMO', param, onAddMemoClose);
        }

        vm.onAddMemo = function (params) {
            var param = {};
            param.day = params.date;
            param.crewProfileId = vm.model.crewDTO.crewProfileId;
            param.crewId = vm.model.crewDTO.crewId;

           // param.memo = CrewingHelper.getMemoForDayAndCrew(param.crewId, param.day);
            PopupManager.openModal('ADD_EDIT_MEMO', param, onAddMemoClose);
        };

        function onAddMemoClose(param) {
        	createLocalStorageVariable(param.crewId);
            loadActualSchedule();
        }

        function createLocalStorageVariable(data){
        	localStorage.setItem("crewList", data);
        }

        vm.assignDirectEvent = function (param, eventType) {
            var stDate, endDate;
            if (param.isMultiple) {
                stDate = param.startDate;
                endDate = param.endDate;
            } else {
                stDate = endDate = param.dateClicked;
            }
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                if(appParamsEnable && vm.model.isSchedulePublish){
                    var details = {
                        title: 'Confirmation',
                        messages: [MessageService.MESSAGES.CREWING.CREW_PORTAL_HIDE]
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
                }else{
                    confirmAssignDirectAction('NO');
                }
            });

            function confirmAssignDirectAction(pass) {
                var isShowInCrewPortal = false;
                if (pass == 'YES') {
                    isShowInCrewPortal = true;
                }

              if (param.isOnProbation == 'Y') {
                var details = {
                  title: 'Confirmation',
                  messages: [MessageService.MESSAGES.CREWING.CREW_PROBATION_OVERRIDE,
                    "Crew Details:",
                    "Id:" + param.crewId,
                    "Name: " + param.crewName],
                  close: 'CLOSE'
                };
                PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
              } else {
                confirmAssignDirectAction('NO');
                // vm.onDirectAction({ param: crewInfo, type: crewingConstants.EVENT_TYPES.sickLeave });
              }

              function confirmAssignDirectAction(pass) {
                if (pass == 'CLOSE' || pass == undefined) {
                  return;
                }

                var isShowInCrewPortal = false;
                var forceAssignLeave = false;
                if (pass == 'YES') {
                  isShowInCrewPortal = true;
                  forceAssignLeave = true;
                }

                CrewingHelper.assignDirectEvent(
                    param.crewProfileId,
                    eventType,
                    stDate,
                    endDate,
                    false,
                    isShowInCrewPortal,
                    function (data) {
                        if (data.success) {
                            loadActualSchedule(false);
                            switch (eventType) {
                                case crewingConstants.EVENT_TYPES.blockDays :
                                {
                                	createLocalStorageVariable(param.crewId);
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_BLOCK_DAYS_SUCCESS);
                                    break;
                                }
                                case crewingConstants.EVENT_TYPES.off :
                                {
                                	createLocalStorageVariable(param.crewId);
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_OFF_SUCCESS);
                                    break;
                                }
                                case crewingConstants.EVENT_TYPES.sickLeave :
                                {
                                	createLocalStorageVariable(param.crewId);
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_SICK_LEAVE_SUCCESS);
                                    break;
                                }
                                case crewingConstants.EVENT_TYPES.annualLeave :
                                {
                                	createLocalStorageVariable(param.crewId);
                                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_ANNUAL_LEAVE_SUCCESS);
                                    break;
                                }
                            }
                            //updateSelectedCrew([param.crewId]);
                            loadActualSchedule(false);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                  },
                  param.isCustomSelectedDates,
                  param.customSelectedDates,
                  forceAssignLeave
                );
                    }
            }
        };


        vm.onSendAlert = function (param) {

            if(vm.model.isSchedulePublish){
                PopupManager.openModal('ALERT', param, onSendAlertClose);
            }
            else{
                MessageService.warning(MessageService.MESSAGES.CREWING.SCHEDULE_NOT_PUBLISH);
            }
        };

        function onSendAlertClose(crewId) {
            if (!!crewId) {
            	createLocalStorageVariable(crewId);
                loadActualSchedule(false);
            }
        }

        function onSendSmsClose(crewId) {
            if (!!crewId) {
            	createLocalStorageVariable(vm.model.crewDTO.crewId);
                loadActualSchedule(false);
            }
        }

        vm.onSendSms = function (param) {
            param.messageContent = CrewingHelper.getDutiesForCrew(param.crew.crewId, param.day.date, 3,null);
            PopupManager.openModal('SMS', param, onSendSmsClose);
        };


        vm.onShowHistory = function (params) {
            var crewProfileId = params.crew.crewDTO.crewProfileId;
            var selectedDate = params.day.date;

            CrewingHelper.getHistory(crewProfileId, selectedDate,
                function (historyResponse) {
                    var param = {
                        history: historyResponse
                    };
                    PopupManager.openModal('HISTORY_DETAILS', param);
                },
                function (msg) {
                    MessageService.error(msg);
                }
            );
        };


        vm.onAssignPairing = function (params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                params.day = params.day[0];
                params.crew = params.crew[0];
                params.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };

                PopupManager.openModalInDiv(params.container, 'ASSIGN_PARING', params, onCloseAssignPairingModal);

                function onCloseAssignPairingModal(assignParingResponse) {
                    assignPairingResponseActions(assignParingResponse);
                }
            });
        };


	vm.onReplacePairing = function (params) {
        CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
          var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
          params.duty = params.duty[0];
          params.crew = params.crew[0];
          params.showInCrewPortalParams = {
            isVisible: appParamsEnable,
            isEnabled: appParamsEnable && vm.model.isSchedulePublish,
            value: !vm.model.isSchedulePublish ? false : true
          };

          console.log("params :", params)
          PopupManager.openModalInDiv(params.container, 'REPLACE_PARING', params, onCloseReplacePairingModal);

          function onCloseReplacePairingModal(assignParingResponse) {
            assignPairingResponseActions(assignParingResponse);
          }
        });
      };

        function assignPairingResponseActions(assignParingResponse) {
            if (!!assignParingResponse) {
                if (!!assignParingResponse.regulationDetails.regulationMap) {
                    var regulationDetailParam = {
                        regulationMap: assignParingResponse.regulationDetails.adaptedRegulationMap,
                        onAcceptPassBackParam: assignParingResponse,
                        isShowCrewPortal: assignParingResponse.isShowCrewPortal
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForPairing);
                } else {
                    //var crewId = CrewingHelper.getCrewIdFromCrewProfileID(assignParingResponse.crewProfileId, vm.model.crewSchedule.nameCollection);
                   // updateSelectedCrew([crewId]);
                	createLocalStorageVariable(vm.model.crewDTO.crewId);
                    loadActualSchedule(false);
                    MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);
                    if (assignParingResponse.otherBlockIllegal) {
                        MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                    }
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                }
            } else {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
            }

            function onCloseRegulationPopupForPairing(params) {
                if (!!params) {
                	createLocalStorageVariable(vm.model.crewDTO.crewId);
                    CrewingHelper.assignPattern(
                        params.crewProfileId,
                        params.pattern,
                        params.isRequest,
                        params.isCallFromDayOff,
                        params.isObsFlight,
                        params.isHideinCrewPortal,
                        false,
                        true,
                        params.isShowCrewPortal,
                        function (data) {
                            MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);
                            if (data.otherBlockIllegal) {
                                MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                            }
                            if (!!data) {

                                    loadActualSchedule(false);
                                    //updateSelectedCrew([crew.crewId]);
                                   // updateSelectedParing(params.pattern, crew.crewTypeCode);

                            }
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                } else {
                    //repositionSelectedOpenParing(assignParingResponse.pattern);
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                }
            }


        }

        vm.onAssignEvent = function (params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                var param = {};
                param.day = params.day[0];
                param.crew = params.crew[0];
                param.container = params.container;
                param.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };
                addEditEvent(param);
            });
        };

        function addEditEvent(param) {
            PopupManager.openModalInDiv(param.container, 'ASSIGN_EVENT', param, onAssignEventClose);

            function onAssignEventClose(params) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                if (!!params && !!params.assignEventResponse) {
                    if (params.assignEventResponse.success) {
                       // updateSelectedCrew([params.assignEventRequestParam.crewId]);
                        loadActualSchedule(false);
                        createLocalStorageVariable(params.assignEventRequestParam.crewId);
                        MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                    } else if (!!params.assignEventResponse.adaptedRegulationMap) {
                        var regulationDetailParam = {
                            regulationMap: params.assignEventResponse.adaptedRegulationMap,
                            onAcceptPassBackParam: params
                        };
                        PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForEvents);
                    }
                }
            }

            function onCloseRegulationPopupForEvents(params) {
                if (!!params) {
                    var isContinueIllegal = false;
                    var isUserConfirm = true;
                    CrewingHelper.assignEditEvent(params.assignEventRequestParam, isContinueIllegal, isUserConfirm,null,null,
                        function (assignEventData) {
                            if (assignEventData.success) {
                                loadActualSchedule(false);
                                createLocalStorageVariable(params.assignEventRequestParam.crewId);
                                MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_EVENT_SUCCESS);
                               // updateSelectedCrew([params.assignEventRequestParam.crewId]);
                            }
                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                }
            }
        }

        vm.onAssignTraining = function (params) {
            CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                var appParamsEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                params.day = params.day[0];
                params.crew = params.crew[0];
                params.showInCrewPortalParams = {
                    isVisible: appParamsEnable,
                    isEnabled: appParamsEnable && vm.model.isSchedulePublish,
                    value: !vm.model.isSchedulePublish ? false : true
                };

                PopupManager.openModalInDiv(params.container, 'ASSIGN_TRAINING', params, onAssignTrainingClose);

                function onAssignTrainingClose(updatedCredIds) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                    if (!!updatedCredIds && updatedCredIds.length > 0) {
                        //updateSelectedCrew(updatedCredIds);
                    	createLocalStorageVariable(updatedCredIds[0]);
                        loadActualSchedule(false);
                    }
                }
            });

        };


        vm.onBlockDelete = function (blocks) {
            deleteBlock(blocks, true);
        };

        function deleteBlock(blocks, isCheckGenderWarnings) {
            //ignore check when multiple blocks selected
            if (!!isCheckGenderWarnings && CrewingHelper.isDistributionCheckApplicable(blocks[0].patternType)) {
                CrewingHelper.checkDistributionWarnings(blocks[0].crewInfo.crewTypeMasterCode, blocks[0].blockId, blocks[0].crewInfo.crewProfileId, true, deleteBlock, blocks);
            } else {
                CrewingHelper.unAssignBlock(blocks,
                    function () {
                       // updateSelectedCrew(getCrewIdsFromBlocks(blocks));
                        //getOpenPairings(vm.model.openPairingParam, true);
                        loadActualSchedule(false);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.RESET_SELECTED_CREW_AND_DAYS);
                        createLocalStorageVariable(blocks[0].crewInfo.crewId);
                        MessageService.success(MessageService.MESSAGES.CREWING.DUTY_REMOVE_SUCCESS);
                    },
                    function () {
                        MessageService.error(MessageService.MESSAGES.CREWING.DUTY_REMOVE_FAILED);
                    }
                );
            }
        }

        vm.onEditBlock = function (params) {
        	getBlockDetail(params);
        };

        function getBlockDetail(param) {
            CrewingHelper.getBlockDetail(
                param.duty.blockId,
                param.duty.crewScheduleBlockId,
                !!param.duty.patternId,
                function (blockDetails) {
                    vm.model.blockDetails = blockDetails;
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.DATA_CHANGED,'test');
                    blockDetails.isTraining = false;
                    blockDetails.crewScheduleBlockId = param.duty.crewScheduleBlockId;
                    blockDetails.patternId = param.duty.patternId;
                    blockDetails.crewProfileId = vm.model.crewDTO.crewProfileId;
                    blockDetails.container = param.container;
                    blockDetails.crew = param.crew;

                    blockDetailResponseActions(blockDetails);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        /*function blockDetailResponseActions(blockDetails) {
            switch (blockDetails.blockType) {
                case  'FLIGHT' :
                {
                    blockDetails.openBlockDetails = true;
                    blockDetails.openBlockDetailsPanel = true;
                    break;
                }
                case 'TRAINING' :
                {
                    blockDetails.isTraining = true;
                    blockDetails.openBlockDetailsPanel = true;break;
                }
                case 'EVENT' :
                {
                    var param = {
                        day: '',
                        crew: blockDetails.crew,
                        isEditMode: true,
                        eventDetails: blockDetails,
                        container: blockDetails.container
                    };
                    addEditEvent(param);
                    break;
                }
            }
        }*/


        function blockDetailResponseActions(blockDetails) {
            switch (blockDetails.blockType) {
                case  'FLIGHT' :
                {
                    SlideInPanelService.openPanel(vm.rightPanelName, blockDetails);
                    break;
                }
                case 'TRAINING' :
                {
                    blockDetails.isTraining = true;
                    SlideInPanelService.openPanel(vm.rightPanelName, blockDetails);
                    break;
                }
                case 'EVENT' :
                {
                	var param = {
                            day: '',
                            crew: blockDetails.crew,
                            isEditMode: true,
                            eventDetails: blockDetails,
                            container: blockDetails.container
                        };
                        addEditEvent(param);
                        break;
                }
            }
        }

        vm.onShowRegulations = function (params) {
//          var crewScheduleBlock = CrewingHelper.getCrewScheduleBlockId(params && params.block && params.block.events);
          var crewScheduleBlockId = params.block.crewScheduleBlockId;
          var crewProfileId = params.crew.crewDTO.crewProfileId;

          CrewingHelper.getRegulation(crewProfileId, crewScheduleBlockId,
              function (response) {
                  var regulationDetailParam = {
                      regulationMap: response.adaptedRegulationMap,
                      onAcceptPassBackParam: null,
                      hideFooterButtons: true
                  };
                  PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam);
              },
              function (msg) {
                  MessageService.error(msg);
              }
          );
      };


      vm.onEmailCrewSchedule = function (params) {
          var crewProfileId = params.crews.crewDTO.crewProfileId;
          CrewingHelper.emailCrewSchedule(
              crewProfileId,
              vm.model.searchDetails.fromDate,
              vm.model.searchDetails.toDate,
              function (date) {
                  if (date) {
                      MessageService.success(MessageService.MESSAGES.CREWING.SCHEDULE_EMAIL_SUCCESS);
                  }
              },
              function (error) {
                  MessageService.error(error);
              }
          );
      };

      vm.onEditPairing = function(params){
          var _editPairingParams = {
              crewId: params.crew.crewId,
              patternId :  params.block.patternId,
              patternStartDate: !!params.block.patternStartDateZulu ? params.block.patternStartDateZulu : params.block.patternStartDate,
              patternEndDate: !!params.block.patternEndDateZulu ? params.block.patternEndDateZulu : params.block.patternEndDate,
              patternName : params.block.patternName,
              crewBase : ''
          };

          var navigateToManagePairing = function(paramToSend){
              var tabName = 'managePairing';
              StorageServices.setTabData(tabName,'editPairingParams',paramToSend);
              TabService.gotoTab(tabName, {
                  patternId: paramToSend.patternId
              });
          };

          _editPairingParams.crewBase = !!vm.model.searchDetails.base ? vm.model.searchDetails.base : applicationConstants.SETTINGS.CREW_BASE_AIRPORT;
          navigateToManagePairing(_editPairingParams);
      };

      vm.onShowPaxMsgDet = function (params) {
        var crewScheduleBlockId = params.block.crewScheduleBlockId;
        var crewProfileId = params.crew.crewDTO.crewProfileId;

        CrewingHelper.getPaxMessageDet(crewProfileId, crewScheduleBlockId,
            function (response) {
                var paxParam = {
                    data: response.paxMsgList
                };
                PopupManager.openModal('PAX_MSG_DETAILS', paxParam);
            },
            function (msg) {
                MessageService.error(msg);
            }
        );
    };

        function loadActualSchedule(showLoading, afterUpdateCallBack){

        	if(!vm.model.isEnableRosterTab){
        		return;
        	}

        	vm.weekDays = moment.weekdaysShort(true);

        	if(angular.isUndefined(vm.model.actualScheduleSearchParam.fromDate)){

        		vm.model.actualScheduleSearchParam.fromDate =  vm.fromDate;
        		vm.model.actualScheduleSearchParam.toDate = vm.toDate;
        	}

            crewScheduleService.searchCrewSchedule(vm.model.actualScheduleSearchParam,showLoading,
                function (response) {

                    vm.fullRoster = CrewingAdaptor.searchCrewScheduleAdaptor(response, vm.model.actualScheduleSearchParam);
                    vm.crewActualSchedule = angular.copy(vm.fullRoster);

                    vm.model.crewDTO = response.crewScheduleDTOs[0].crewDTO;
                    vm.crewDetails= angular.copy(vm.model.crewDTO);
                    vm.model.crewDTO.crewExpiryDTOs = crewScheduleService.adaptExpiry(vm.model.crewDTO.crewExpiryDTOs,vm.model.actualScheduleSearchParam);
                    vm.model.alertsDTO = response.crewScheduleDTOs[0].alertsDTOs;
                    vm.model.memoDTO = response.crewScheduleDTOs[0].memoDTOs;

                    vm.model.publishScheduleSearchParam.fromDate = vm.fromDate;
                    vm.model.publishScheduleSearchParam.toDate = vm.toDate;
                    vm.model.publishScheduleSearchParam.crewId = response.crewScheduleDTOs[0].crewDTO.crewId;
                    vm.model.publishScheduleSearchParam.crewProfileId = response.crewScheduleDTOs[0].crewDTO.crewProfileId;

                    vm.model.searchDetails.crewID = response.crewScheduleDTOs[0].crewDTO.crewId;

                    crewSchAssignTraningModel.setCrewInfo(vm.model.crewDTO);

                    CrewingHelper.setCrewScheduleData(vm.fullRoster);
                    //loadPublishSchedule();
                    loadCrewAirportsExclusion();
                    loadCrewExclusion();
                    searchCrewNote();
                    getTrackingTimeZone();
                    isCrewSchedulePublishedForCrewProfileId();
                    if(!vm.isLoadCrewList){
                        loadCrewList(vm.model.crewDTO.crewTypeCode);
                    }
                    crewSchAssignTraningLogic.loadTrainingsForLastRequest();
                    if(!angular.isUndefined(afterUpdateCallBack)){
                        afterUpdateCallBack();
                    }

                    adaptActualScheduleData();
                },
                function (error) {
                	if(!error[0] == "CES-756: Crew not found."){
                		 MessageService.error(error[0]);
                	}
                }
            );
        }

        function loadPublishSchedule(){
            vm.model.scheduleType= 'publish';
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREW_SCHEDULE.TYPE_CHANGE);

            if(!!vm.model.publishScheduleSearchParam.fromDate){
                crewScheduleService.searchCrewPublishSchedule(vm.model.publishScheduleSearchParam,
                    function (response) {
                        vm.model.crewPublishDetails = response;
                        vm.model.crewPublishSchedule= response.publishedDuties;
                    },
                    function (error) {
                        MessageService.error(error[0]);
                    }
                );
            }

        }

        function loadCrewAirportsExclusion(){
            crewScheduleService.loadCrewAirportsExclusion(vm.model.crewDTO.crewProfileId,
                function (response) {
                    vm.model.airportExclusion= response;
                },
                function (error) {
                }
            );
        }

        function loadCrewExclusion(){
            var param={};
            param.crewProfId = vm.model.crewDTO.crewProfileId;
            param.isActive = true;
            crewScheduleService.loadCrewExclusion(param,
                function (response) {
                    vm.model.crewExclusion = response;
                },
                function (error) {
                }
            );
        }

        function searchCrewNote(){
            var param={};
            param.crewProfileId = vm.model.crewDTO.crewProfileId;
            param.fromDate= vm.model.actualScheduleSearchParam.fromDate;
            param.toDate= vm.model.actualScheduleSearchParam.toDate;
            crewScheduleService.searchCrewNote(param,
                function (response) {
                    if(!!response && response.length){
                        vm.model.isNoteAvailable=true;
                    }
                    vm.model.crewNotes = response;
                },
                function (error) {
                }
            );
        }

        function getTrackingTimeZone() {
            CrewingHelper.getTimeZoneText(
                function (timeZoneResponse) {
                    vm.model.timeZoneText = timeZoneResponse.message;
                },
                function (error) {
                    console.log(error);
                }
            );
        }

      function isCrewSchedulePublishedForCrewProfileId() {
        CrewingHelper.checkIsPublishedByCrewProfileId(
          [vm.model.crewDTO.crewProfileId],
          angular.isUndefined(vm.model.searchDetails.fromDate)? vm.fromDate:vm.model.searchDetails.fromDate,
          angular.isUndefined(vm.model.searchDetails.toDate)? vm.toDate:vm.model.searchDetails.toDate,
          function (isPublished) {
            vm.model.isSchedulePublish =isPublished;
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.IS_CREW_SCHEDULE_PUBLISHED, isPublished);
          },
          function (error) {
            MessageService.error(error);
          }
        );
      }

        function adaptActualScheduleData() {
            // vm.crewSchedule = _.groupBy(vm.crewSchedule,'checkInDate');
            mapScheduleWithCalendar();
            mapAlertsWithCalendar();
            mapMemosWithCalendar();
            mapExpiryWithCalendar();
        }


        function mapScheduleWithCalendar() {
        	angular.forEach(vm.crewActualSchedule.schedule[0].adaptedRosterDutyDTOs, function (schedule, scheduleIndex) {
        		angular.forEach(vm.calendar, function (row, key) {
        			row.isExpand = false;
        			angular.forEach(row, function (day) {

        				if (schedule.patternStartDate === day.date) {

        					schedule.leftPos = getPositionFromDate(schedule.patternStartDate, schedule.patternStartTime, schedule.patternStartDate);
        					var endPos = getPositionFromDate(schedule.patternEndDate, schedule.patternEndTime, schedule.patternStartDate);
        					schedule.width = endPos - schedule.leftPos;
        					if (schedule.events.length) {
        						angular.forEach(schedule.events, function (event) {
        							if (event.type === "REST") {
        								event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, schedule.patternStartDate);
        								var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, schedule.patternStartDate);
        								event.width = endPos - event.leftPos;
        							}
        							else {
        								event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, schedule.patternStartDate);
        								var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, schedule.patternStartDate);
        								event.width = endPos - event.leftPos;
        							}


        						});
        					}
        					day.actualSchedule.push(schedule);

        					for(var i = key;i< vm.calendar.length;i++){
        						var nextWeekStart = vm.calendar[i].nextWeekStart;
        						if (nextWeekStart!="" &&(moment(schedule.patternEndDate, 'DD/MM/YYYY').diff(moment(nextWeekStart, 'DD/MM/YYYY')) >= 0 || moment(schedule.restEndDate, 'DD/MM/YYYY').diff(moment(nextWeekStart, 'DD/MM/YYYY')) >= 0)) {
        							if (vm.calendar[i + 1] !== undefined) {
        								var tempSchedule = angular.copy(schedule);
        								tempSchedule.leftPos = getPositionFromDate(tempSchedule.patternStartDate, tempSchedule.patternStartTime, nextWeekStart);
        								var endPos = getPositionFromDate(tempSchedule.patternEndDate, tempSchedule.patternEndTime, nextWeekStart);
        								tempSchedule.width = endPos - tempSchedule.leftPos;
        								if (tempSchedule.events.length) {
        									angular.forEach(tempSchedule.events, function (event) {
        										if (event.type === "REST") {
        											event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, nextWeekStart);
        											var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, nextWeekStart);
        											event.width = endPos - event.leftPos;
        										}
        										else {
        											event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, nextWeekStart);
        											var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, nextWeekStart);
        											event.width = endPos - event.leftPos;
        										}
        									});
        								}
        								vm.calendar[i + 1][0].actualSchedule.push(tempSchedule);//set next week value
        							}
        						}
        					}
        				}
        				else {
        					if ((_.find(vm.originalCal, {date: schedule.patternStartDate}) === undefined) && schedule.patternEndDate === day.date && scheduleIndex === 0) {
        						schedule.leftPos = getPositionFromDate(schedule.patternStartDate, schedule.patternStartTime, day.date);
        						var endPos = getPositionFromDate(schedule.patternEndDate, schedule.patternEndTime, day.date);
        						schedule.width = endPos - schedule.leftPos;
        						if (schedule.events.length) {
        							angular.forEach(schedule.events, function (event) {
        								if (event.type === "REST") {
        									event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, day.date);
        									var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, day.date);
        									event.width = endPos - event.leftPos;
        								}
        								else {
        									event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, day.date);
        									var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, day.date);
        									event.width = endPos - event.leftPos;
        								}


        							});
        						}
        						day.actualSchedule.push(schedule);
        					}

        				}
        			});
        		});

        	});

        }

        function mapAlertsWithCalendar() {
            angular.forEach(vm.calendar, function (row, key) {
                angular.forEach(row, function (day) {
                    if (!!day.alertDetails) {
                        day.alertDetails = [];
                    }

                });
            });
            angular.forEach(vm.alertsDetails, function (alert) {
                angular.forEach(vm.calendar, function (row, key) {
                    angular.forEach(row, function (day) {
                        if (alert.alertDate === day.date) {
                            day.alertDetails.push(alert);
                        }

                    });
                });
            });
        }

        function mapMemosWithCalendar() {
            angular.forEach(vm.calendar, function (row, key) {
                angular.forEach(row, function (day) {
                    day.memoDetails = [];
                });
            });
            angular.forEach(vm.memoDetails, function (memo) {
                angular.forEach(vm.calendar, function (row, key) {
                    angular.forEach(row, function (day) {
                        if (memo.memoDate === day.date) {
                            var temp = day.memoDetails.indexOf(memo);
                            day.memoDetails.push(memo);
                        }

                    });
                });
            });
        }

        function mapExpiryWithCalendar() {
            angular.forEach(vm.calendar, function (row, key) {
                angular.forEach(row, function (day) {
                    day.expiry = [];

                });
            });
            angular.forEach(vm.crewDetails.crewExpiryDTOs, function (expiry) {
                angular.forEach(vm.calendar, function (row, key) {
                    angular.forEach(row, function (day) {
                        if (expiry.dateOfExpiry === day.date) {
                            day.expiry.push(expiry);
                        }

                    });
                });
            });
        }

        function getPositionFromDate(date, time, relativeTo) {
            var reqDate = date + ' ' + time;
            var reqDateTime = moment(reqDate, 'DD/MM/YYYY HH:mm');
            var relativeDate = moment(relativeTo, 'DD/MM/YYYY');
            var diffFromStart = reqDateTime.diff(relativeDate, 'm');
            return Math.round(diffFromStart * vm.minuteToPixelRatio);
        }

        function removeLanguageSkillsFromMasterList(crewLangSkills) {

          angular.forEach(crewLangSkills,function (skill) {

            var index = _.findIndex(vm.model.languageList, {languageCode: skill.languageCode})
            if(index > -1){
              vm.model.languageList.splice(index, 1);
            }

          })
        }

      function getCrewACMIEffectiveRanges() {
        vm.model.crewACMIAssignmentRanges = [];
        var param = {};
        param.crewProfileId = vm.model.crewDetails.crewProfileId;
        param.onlyEffectiveRanges = true;
        ProfileService.getCrewAcmiRangesForEdit(param,
          function (response) {
            vm.model.crewACMIAssignmentRanges = response;
          },
          function (error) {
            console.log('Crew ACMI data retrieval error')
          }
        );
      }

      vm.addCrewACMIDateRange = function (dateRangesDTO) {
        var param = {};
        param.crewProfileId = vm.model.crewDetails.crewProfileId;
        param.acmiRangeStartDate = dateRangesDTO.effectiveAcmiFromDate;
        param.acmiRangeEndDate = dateRangesDTO.effectiveAcmiToDate;
        param.a320Qualified = dateRangesDTO.a320Qualified;
        param.a321Qualified = dateRangesDTO.a321Qualified;
        param.rangeDesc = dateRangesDTO.rangeDesc;
        param.acmiType = dateRangesDTO.acmiType.acmiCode;
        // param.version = -1;

        ProfileService.addCrewACMIRange(param,
          function (response) {
            if (response.success) {
              getCrewACMIEffectiveRanges();
              if((response.messages==null)) {
                MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
              }else{
                MessageService.error("Date range overlapping.");
              }
            }
            else if (response.messages[0] != null) {
              MessageService.error(response.messages[0]);
            }
            else {
              MessageService.error('Adding Failed!');
            }
          },
          function (error) {
            MessageService.error(error);
          }
        );
      };

      vm.onACMIRangeEditSave = function () {
        var param = {
          crewProfileId: vm.model.crewDetails.crewProfileId,
          editedAcmiRanges: vm.model.crewACMIAssignmentRanges
        }
        ProfileService.saveEditACMIRanges(param,
          function (response) {
            if (response.success) {
              MessageService.success('Successfully Saved');
            } else if (response.messages[0] != null) {
              MessageService.error(response.messages[0]);
            }
            else {
              MessageService.error('Saving Failed!');
            }
            getCrewACMIEffectiveRanges();
          },
          function (error) {
            MessageService.error(error);
          })
      };

      vm.onACMIRangeDelete = function (rangeId) {
        var param = {
          crewProfileId: vm.model.crewDetails.crewProfileId,
          rangeId: rangeId
        }
        ProfileService.onACMIRangeDelete(param,
          function (response) {
            if (response.success) {
              MessageService.success('Successfully Deleted');
            } else if (response.messages[0] != null) {
              MessageService.error(response.messages[0]);
            }
            else {
              MessageService.error('Delete Failed!');
            }
            getCrewACMIEffectiveRanges();
          },
          function (error) {
            MessageService.error(error);
          })
      };

      /**
       * Load assigned batches for the current crew profile
       */
      function loadAssignedBatches() {
          if (!vm.model.crewDetails.crewProfileId) return;
          ProfileService.getAssignedBatchesForCrew(vm.model.crewDetails.crewProfileId,
              function (batchList) {
                  vm.model.assignedCrewBatches = batchList;
              },
              function (error) {
                  console.log('Crew attribute retrieval error');
              }
          );
      }

      /**
       * Save crew attribute assignment changes (called from component on Save click).
       * Processes all adds and removes, then reloads once at the end.
       */
      vm.saveCrewBatchChanges = function (batchesToAdd, batchesToRemove) {
          var totalOps = (batchesToAdd ? batchesToAdd.length : 0) + (batchesToRemove ? batchesToRemove.length : 0);
          if (totalOps === 0) return;

          var completedOps = 0;
          var hasError = false;

          function onOpComplete(isError) {
              if (isError) hasError = true;
              completedOps++;
              if (completedOps >= totalOps) {
                  if (!hasError) {
                      MessageService.success('Crew attributes updated successfully');
                  }
                  loadAssignedBatches();
              }
          }

          _.each(batchesToAdd, function (code) {
              ProfileService.assignCrewToBatch(vm.model.crewDetails.crewProfileId, code,
                  function (response) {
                      if (!response.success) {
                          MessageService.error(response.messages ? response.messages[0] : 'Assign to batch failed');
                      }
                      onOpComplete(!response.success);
                  },
                  function (error) {
                      MessageService.error(error);
                      onOpComplete(true);
                  }
              );
          });

          _.each(batchesToRemove, function (code) {
              ProfileService.removeCrewFromBatch(vm.model.crewDetails.crewProfileId, code,
                  function (response) {
                      if (!response.success) {
                          MessageService.error(response.messages ? response.messages[0] : 'Remove from batch failed');
                      }
                      onOpComplete(!response.success);
                  },
                  function (error) {
                      MessageService.error(error);
                      onOpComplete(true);
                  }
              );
          });
      };

    }
}());
